<template>
    <div>
        <button :class="buttonCss" id="buttonOpenModal" @click="openModal">
            <slot name="content"></slot>
            {{ buttonText }}
        </button>
        <modal
            v-if="showModal"
            root-id="loginModal"
            root-classes="modal show"
            modal-width="modal-xs"
            :ignore-escape="true"
        >
            <template #modal-content>
                <div class="modal-close-container close-absolute absolute right-0 sm:-top-6 top-0">
                    <button
                        id="modalClose"
                        type="button"
                        class="modal-close absolute sm:-right-6 right-0"
                        data-miss="#loginModal"
                        @click="closeModal"
                    >
                        <svg
                            width="25"
                            xmlns="http://www.w3.org/2000/svg"
                            stroke="currentColor"
                            fill="none"
                            viewBox="0 0 24 24"
                            role="img"
                            aria-label="Icono para cerrar mensaje"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                </div>
            </template>
            <template #modal-container>
                <div class="flex sm:flex-col items-end sm:items-center justify-center">
                    <h1
                        class="leading-none md:leading-tight font-medium text-2xl sm:text-3xl text-gray-700 text-center sm:mr-3 mr-1"
                        id="modal-headline"
                    >
                        Bienvenido a
                    </h1>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 236 41.4"
                        class="h-5 sm:h-6 pb-2px ml-1 sm:ml-0"
                    >
                        <path
                            d="M7.4 39.3C5 37.9 3.1 36 1.9 33.7S0 28.8 0 25.9c0-2.7.6-5.4 1.9-7.7s3.1-4.3 5.4-5.6 5-1.9 8.1-1.9c3.1 0 5.8.8 8.1 2.1s4.3 3.3 5.4 5.6c1.4 2.3 1.9 4.8 1.9 7.7s-.6 5.4-1.9 7.7c-1.4 2.3-3.1 4.3-5.4 5.6-2.3 1.4-5.2 1.9-8.1 1.9-3 .1-5.7-.7-8-2z"
                            fill="#64d877"
                        />
                        <path
                            d="M44.1 39.9c-2.1-1-3.7-2.5-4.8-4.8-1.2-2.1-1.7-5-1.7-8.3v-16h7v15.7c0 2.7.6 4.8 1.7 6.2 1.2 1.4 2.9 2.1 5.2 2.1 2.3 0 4.1-.8 5.2-2.1 1.2-1.4 1.7-3.5 1.7-6.2V10.8h7v15.9c0 3.5-.6 6.2-1.7 8.3-1.2 2.1-2.9 3.7-4.8 4.8-1.9 1.2-4.4 1.5-7.2 1.5-3.1.1-5.5-.5-7.6-1.4zM79.5 10.8v5.4c.8-1.7 1.7-2.9 3.1-3.9s2.9-1.4 4.8-1.4h3.1v6h-2.7c-1.5 0-2.9.4-4.3 1.2-1.2.8-2.1 1.9-2.9 3.3-.6 1.5-1 3.3-1 5.2v13.7h-7V10.8h6.9zM106.4 39.9c-1.7-1-3.3-2.5-4.3-4.3v5h-6.6V0h7v11.8l-.2 3.9c1-1.7 2.3-3.1 4.1-4.1 1.7-1 3.7-1.5 5.8-1.5 2.7 0 5.2.8 7.4 2.1 2.3 1.4 4.1 3.3 5.2 5.6 1.2 2.3 1.9 5 1.9 7.9 0 2.9-.6 5.4-1.9 7.9-1.2 2.3-2.9 4.3-5.2 5.6-2.1 1.4-4.6 2.1-7.4 2.1-1.9.1-4.1-.5-5.8-1.4zm9.1-6c1.4-.8 2.3-1.7 3.1-3.3.8-1.4 1.2-3.1 1.2-4.8 0-1.7-.4-3.5-1.2-4.8-.8-1.4-1.7-2.5-3.1-3.3-1.4-.8-2.7-1.2-4.4-1.2-1.5 0-3.1.4-4.4 1.2-1.4.8-2.3 1.9-3.1 3.3-.8 1.4-1.2 2.9-1.2 4.6 0 1.7.4 3.3 1.2 4.8.8 1.4 1.9 2.5 3.1 3.3 1.4.8 2.7 1.2 4.4 1.2 1.5.1 3-.3 4.4-1zM138.1 39.3c-2.1-1.4-3.9-3.3-5-5.6-1.2-2.3-1.7-5-1.7-7.9s.6-5.4 1.7-7.9c1.4-2.3 2.9-4.3 5-5.6 2.1-1.4 4.4-2.1 7-2.1 2.3 0 4.6.6 6.4 1.5 1.9 1 3.3 2.5 4.3 4.3v-5h6.8v29.6H156v-5c-1 1.9-2.3 3.3-4.3 4.3-1.9 1-4.1 1.5-6.4 1.5-2.5 0-5-.8-7.2-2.1zm13.2-5.6c1.4-.8 2.3-1.9 3.1-3.3s1.2-2.9 1.2-4.6-.4-3.3-1.2-4.6-1.7-2.5-3.1-3.3c-1.4-.8-2.7-1.2-4.4-1.2s-3.1.4-4.4 1.2c-1.4.8-2.3 1.9-3.1 3.3s-1.2 2.9-1.2 4.8.4 3.5 1.2 4.8 1.9 2.5 3.1 3.3c1.2.8 2.9.8 4.6.8 1.5-.1 2.8-.5 4.2-1.2zM177.2 10.8v4.6c.8-1.7 2.1-2.9 4.1-4.1 1.7-1 3.9-1.5 6-1.5 3.9 0 7 1.2 8.9 3.7 1.9 2.5 2.9 6 2.9 10.8v15.9h-7V24.4c0-2.9-.6-4.8-1.7-6.2s-2.9-1.9-5-1.9c-1.4 0-2.7.4-3.9 1-1.2.8-2.1 1.7-2.9 3.1-.8 1.4-1.2 2.9-1.2 4.8v15.1h-7V10.8h6.8zM212.6 39.3c-2.3-1.4-4.3-3.3-5.6-5.6-1.4-2.3-1.9-5-1.9-7.9s.6-5.4 1.9-7.9c1.4-2.3 3.3-4.3 5.6-5.6 2.3-1.4 5-2.1 7.9-2.1 2.9 0 5.6.8 7.9 2.1 2.3 1.4 4.3 3.3 5.6 5.6 1.4 2.3 1.9 5 1.9 7.9s-.6 5.4-1.9 7.9c-1.4 2.3-3.3 4.3-5.6 5.6-2.3 1.4-5 2.1-8.1 2.1-2.7 0-5.4-.8-7.7-2.1zm12.6-5.6c1.4-.8 2.3-1.9 3.1-3.3s1.2-2.9 1.2-4.8c0-1.7-.4-3.3-1.2-4.6s-1.7-2.5-3.1-3.3c-1.4-.8-2.7-1.2-4.4-1.2s-3.1.4-4.4 1.2c-1.4.8-2.3 1.9-3.1 3.3s-1.2 2.9-1.2 4.6c0 1.7.4 3.3 1.2 4.8.8 1.4 1.7 2.5 3.1 3.3 1.4.8 2.7 1.2 4.4 1.2s3-.5 4.4-1.2z"
                            fill="#636363"
                        />
                    </svg>
                </div>
                <p class="text-gray-600 leading-tight text-center mt-5 sm:mt-3">
                    Para disfrutar de todos tus descuentos mensuales es necesario iniciar sesión.
                </p>
                <form
                    class="mt-5 sm:mt-8"
                    :class="{ active: loginButtonClicked }"
                    id="loginModalForm"
                    @submit.prevent="login"
                    @keydown="form.errors.clear($event.target.name)"
                >
                    <input
                        id="email"
                        type="email"
                        name="email"
                        v-model="form.email"
                        placeholder="Correo electrónico"
                        required
                        class="appearance-none block w-full px-3 py-3 border border-gray-400 rounded-md placeholder-gray-500 focus:ring-opacity-30 focus:border-green-300 focus:outline-none focus:ring focus:ring-green-300 transition duration-150 ease-in-out sm:leading-5 mb-3"
                    />
                    <span
                        id="emailErrors"
                        v-if="form.errors.has('email')"
                        v-text="form.errors.get('email')"
                        class="text-red-500 text-sm"
                    ></span>
                    <div class="relative mt-2 rounded-md shadow-sm">
                        <password-toggle>
                            <input
                                id="password"
                                type="password"
                                name="password"
                                v-model="form.password"
                                class="appearance-none block w-full py-3 pl-3 pr-10 border border-gray-400 rounded-md placeholder-gray-500 focus:ring-opacity-30 focus:border-green-300 focus:outline-none focus:ring focus:ring-green-300 transition duration-150 ease-in-out sm:leading-5"
                                placeholder="Escribe tu contraseña"
                                required
                            />
                        </password-toggle>
                    </div>
                    <span
                        id="passwordErrors"
                        v-if="form.errors.has('password')"
                        v-text="form.errors.get('password')"
                        class="text-red-500 text-sm"
                    ></span>
                    <div class="mt-3 flex items-center justify-between">
                        <div class="flex items-center">
                            <input
                                id="remember"
                                name="remember"
                                type="checkbox"
                                class="form-checkbox h-4 w-4 text-indigo-600 border border-gray-400 rounded focus:outline-none focus:ring-1 focus:ring-indigo-400 transition duration-150 ease-in-out"
                            />
                            <label for="remember" class="ml-2 block text-sm leading-5 text-gray-600"
                                >Recordar contraseña</label
                            >
                        </div>
                    </div>
                    <button
                        id="loginButton"
                        type="submit"
                        class="btn btn-primary w-full sm:mt-8 mt-5"
                        :class="{ disabled: disableButton() }"
                    >
                        Iniciar sesión
                    </button>
                </form>
                <p class="text-gray-500 text-center mt-5">
                    ¿Aún no tienes cuenta?
                    <a
                        href="/registro"
                        class="inline-block text-indigo-600 hover:text-indigo-800 transition duration-300 ease-in-out"
                        >Regístrate aquí</a
                    >
                </p>
            </template>
        </modal>
    </div>
</template>

<script>
import PasswordToggle from './PasswordToggle';
import Form from '../support/Form';
import sweetAlert from 'sweetalert';
import Modal from './Modal';

export default {
    name: 'ModalLogin',
    components: {
        Modal,
        PasswordToggle,
    },

    props: {
        redirectUrl: String,
        buttonText: String,
        buttonCss: {
            type: String,
            default: 'btn btn-primary md:inline-block block md:w-auto w-full',
        },
    },

    data() {
        return {
            showModal: false,
            loginButtonClicked: false,
            form: new Form({
                email: '',
                password: '',
            }),
        };
    },

    computed: {
        inputsAreFilled() {
            if (!this.form.email) {
                return false;
            }

            if (!this.form.password) {
                return false;
            }

            return true;
        },
    },

    methods: {
        openModal() {
            this.showModal = true;
        },

        disableButton() {
            return !this.inputsAreFilled;
        },

        closeModal() {
            setTimeout(() => {
                $('body, html').removeClass('overflow-hidden');

                this.showModal = false;
                this.email = '';
                this.password = '';
            }, 500);
        },

        login() {
            this.loginButtonClicked = true;

            this.form
                .post('/login')
                .then(() => {
                    sweetAlert({
                        title: 'Éxito',
                        text: 'Se inició tu sesión correctamente.',
                        timer: 4000,
                        icon: 'success',
                        confirmButtonText: 'Cerrar',
                        buttonsStyling: false,
                        customClass: {
                            confirmButton: 'btn btn-green inline-block py-3 px-10',
                        },
                    }).then(() => {
                        location.href = this.redirectUrl;
                    });
                })
                .catch(() => {
                    this.loginButtonClicked = false;
                    sweetAlert('Error', 'Verifica tus datos.', 'error');
                });
        },
    },
};
</script>
